import { queryOptions, useQuery, useQueryClient, type QueryClient } from '@tanstack/react-query';
import { hydraUiApi } from '@/services/api';
import type { QueryConfig } from '../shared/react-query-types';
import { requireWorkspaceId } from '../shared/workspace';
import { customFormKeys, parseCustomForm, type CustomForm } from './entity';

const STALE_TIME = 60_000;

/** @public All custom forms for the workspace. */
export async function getCustomForms(workspaceId: number, qc: QueryClient): Promise<CustomForm[]> {
  const data = await hydraUiApi.customForms.list({
    params: { path: { environment_id: String(workspaceId) } },
  });
  const parsed = (data.custom_forms ?? []).map(parseCustomForm);
  for (const f of parsed) {
    qc.setQueryData(customFormKeys.detail(workspaceId, f.id), f);
  }
  return parsed;
}

/** @public */
export const getCustomFormsQueryOptions = (workspaceId: number, qc: QueryClient) =>
  queryOptions({
    queryKey: customFormKeys.list(workspaceId, undefined),
    queryFn: () => getCustomForms(workspaceId, qc),
    staleTime: STALE_TIME,
  });

/** @public */
export const useCustomForms = ({
  queryConfig,
}: { queryConfig?: QueryConfig<typeof getCustomFormsQueryOptions> } = {}) => {
  const workspaceId = requireWorkspaceId();
  const qc = useQueryClient();
  return useQuery({ ...getCustomFormsQueryOptions(workspaceId, qc), ...queryConfig });
};
